import { useState } from "react";
import { homeService, subscriptionService } from "@miplatform/api";
import {
  EMAIL_ENTITY_TYPE,
  EMAIL_ENTITY_TYPE_TO_ENTITY_MAP,
  HTTP_STATUSES,
} from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { useDocumentsViewModel } from "@miplatform/view-models";
import { useSession } from "@mibuildweb/hooks";
import { DEFAULT_EMAIL_FILE_CATEGORY } from "./emailFormConstants";
import { useEmailFormAttemptViewModel } from "./useEmailFormAttemptViewModel";
import { useEmailFormOrderViewModel } from "./useEmailFormOrderViewModel";

const VIEW_MODEL_MAP = {
  [EMAIL_ENTITY_TYPE.ATTEMPT]: useEmailFormAttemptViewModel,
  [EMAIL_ENTITY_TYPE.ORDER]: useEmailFormOrderViewModel,
};

export const useEmailFormViewModel = ({
  entity,
  entityType,
  step,
  attempt,
  templateType,
  files,
  getValues,
  openCloseoutRef,
  onClose,
  onCloseoutDrawerOpen,
}) => {
  const {
    session: { tenantId, userId },
  } = useSession();
  const { loading, getDocumentCategories } = useDocumentsViewModel();
  const [documentCategory, setDocumentCategory] = useState(null);
  const [home, setHome] = useState(null);
  const [account, setAccount] = useState(null);
  const [user, setUser] = useState(null);
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const viewModel = VIEW_MODEL_MAP[entityType]({
    account,
    entity,
    step,
    attempt,
    templateType,
    files,
    documentCategory,
    getValues,
    openCloseoutRef,
    onClose,
    onCloseoutDrawerOpen,
  });

  const getHome = () =>
    stateManager.run(async () => {
      const response = await homeService.homes.getById({
        id: entity?.home?.id,
      });

      if (response.status === HTTP_STATUSES.OK) {
        setHome(response.data);
      }
    });

  const getAccount = () =>
    stateManager.run(async () => {
      const response = await subscriptionService.subscriptions.get(tenantId);

      if (response.status === HTTP_STATUSES.OK) {
        setAccount(response.data);
      }
    });

  const getUser = () =>
    stateManager.run(async () => {
      const response = await subscriptionService.users.get(userId);
      if (response.status === HTTP_STATUSES.OK) {
        setUser(response.data);
      }
    });

  const getDocumentCategoryOptions = async () => {
    const categories = await getDocumentCategories(
      EMAIL_ENTITY_TYPE_TO_ENTITY_MAP[entityType]
    );
    setDocumentCategory(
      categories.find(
        (category) => category.name === DEFAULT_EMAIL_FILE_CATEGORY
      ) || categories[0]
    );
  };

  return {
    ...viewModel,
    home,
    account,
    user,
    isLoading: loading || isLoading || viewModel.isLoading,
    documentCategory,
    getDocumentCategoryOptions,
    getAccount,
    getUser,
    getHome,
  };
};
